/**
 * @generated SignedSource<<7d95a12b061ade2e68cb3366d9b4aafc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type versionList_softwareReleasesMoveIssuesBetweenVersions_jiraVersion$data = {
  readonly canAddAndRemoveIssues: boolean | null | undefined;
  readonly id: string;
  readonly versionId: string;
  readonly " $fragmentSpreads": FragmentRefs<"issueWarning_softwareReleasesMoveIssuesBetweenVersions_jiraVersion">;
  readonly " $fragmentType": "versionList_softwareReleasesMoveIssuesBetweenVersions_jiraVersion";
};
export type versionList_softwareReleasesMoveIssuesBetweenVersions_jiraVersion$key = {
  readonly " $data"?: versionList_softwareReleasesMoveIssuesBetweenVersions_jiraVersion$data;
  readonly " $fragmentSpreads": FragmentRefs<"versionList_softwareReleasesMoveIssuesBetweenVersions_jiraVersion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "versionList_softwareReleasesMoveIssuesBetweenVersions_jiraVersion",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "versionId"
      },
      "action": "THROW",
      "path": "versionId"
    },
    {
      "kind": "ScalarField",
      "name": "canAddAndRemoveIssues"
    },
    {
      "kind": "FragmentSpread",
      "name": "issueWarning_softwareReleasesMoveIssuesBetweenVersions_jiraVersion"
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "3401c25196bed99e751ba57506a3021b";

export default node;
